import vanTwoPic from "./index.vue";

/* istanbul ignore next */
vanTwoPic.install = function(Vue) {
  Vue.component(vanTwoPic.name, vanTwoPic);
};

export default vanTwoPic;
